import { FormType, InputType } from '@fitogest/reactive-form-builder/interfaces';
import { TareaLimpiezaGeneralModel } from '../../../../../../models/tareas/tarea-limpieza-general.model';
import { MtoReactiveFormDefinition, MtoSectionSpec } from '../../../mto-reactive/mto-reactive-form-definition';

export class TareasMtoLimpiezaGeneralFormDefinition extends MtoReactiveFormDefinition<TareaLimpiezaGeneralModel> {
    constructor(type: FormType = FormType.CREATION, model: Partial<TareaLimpiezaGeneralModel> = {}) {
        super(type, model);

        this.initializeMtoForm({
            name: 'limpieza',
            header: 'Datos de limpieza general',
            database: 'tareas_mto_limpieza_general',
            signatureFolder: 'limpieza',
            sections: this.getSections(),
        });
    }

    private getSections(): MtoSectionSpec<TareaLimpiezaGeneralModel>[] {
        return [
            { name: 'Datos de limpieza general', fields: [...this.getDefaultMainFieldSpecs()] },
            { name: 'Limpieza general', fields: [
                this.field('limpieza_calles', `Limpieza de calles`, InputType.SWITCH, { width: 3 }),
                this.field('bolsas_basura', `Cambio de bolsas de basura`, InputType.SWITCH, { width: 3 }),
                this.field('limpieza_desagues', `Limpieza de desagües`, InputType.SWITCH, { width: 3 }),
            ] },
            this.workerSection('Profesionales'),
            this.workOrderSection(),
            this.observationSection('Observaciones'),
        ];
    }
}
